import { InfoIcon } from '@/assets/icons'
import React, { useState } from 'react'
import { TooltipContainer, TooltipIcon, TooltipText } from './Tooltip.styles'

interface TooltipProps {
	text: string
	children?: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
	const [isVisible, setIsVisible] = useState(false)

	return (
		<TooltipContainer
			onMouseEnter={() => setIsVisible(true)}
			onMouseLeave={() => setIsVisible(false)}
		>
			{children || (
				<TooltipIcon>
					<InfoIcon width={20} height={20} fill="currentColor" />
				</TooltipIcon>
			)}
			{isVisible && <TooltipText>{text}</TooltipText>}
		</TooltipContainer>
	)
}

export default Tooltip

